export default __webpack_public_path__ + "static/media/3.4b337694.png";